import PropTypes from 'prop-types';
import Layout from './Layout';

export default function SubmitPage({ onPreviousStep }) {
    return (
        <div className="py-6 px-4 space-y-4 sarabun whitespace-pre-wrap">
            <Layout>
                <div className="p-6">
                    <div className="items-center gap-2 flex">
                        <Icon />
                        <span>ส่งแบบฟอร์มสำเร็จ!</span>
                    </div>
                    <button
                        onClick={onPreviousStep}
                        type="button"
                        className="items-center gap-2 flex text-[#1890FF] mt-6"
                    >
                        <svg
                            width="13"
                            height="11"
                            viewBox="0 0 13 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.0001 5.19204H3.27612L6.80479 1.66337L5.86212 0.720703L0.724121 5.8587L5.86212 10.9967L6.80479 10.054L3.27612 6.52537H13.0001V5.19204Z"
                                fill="#1890FF"
                            />
                        </svg>
                        <strong>กลับไปหน้าแรก</strong>
                    </button>
                </div>
            </Layout>
        </div>
    );
}

const Icon = () => (
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="10" cy="10.3594" r="10" fill="#4ACE8F" />
        <path
            d="M14.4735 7.16595C14.4115 7.10346 14.3378 7.05387 14.2565 7.02002C14.1753 6.98618 14.0881 6.96875 14.0001 6.96875C13.9121 6.96875 13.825 6.98618 13.7437 7.02002C13.6625 7.05387 13.5888 7.10346 13.5268 7.16595L8.56013 12.1393L6.47346 10.0459C6.40911 9.98379 6.33315 9.93491 6.24992 9.90211C6.16668 9.86931 6.0778 9.85322 5.98834 9.85477C5.89889 9.85632 5.81062 9.87547 5.72857 9.91113C5.64651 9.94679 5.57229 9.99827 5.51013 10.0626C5.44797 10.127 5.39909 10.2029 5.36629 10.2862C5.33349 10.3694 5.3174 10.4583 5.31895 10.5477C5.3205 10.6372 5.33965 10.7255 5.37531 10.8075C5.41097 10.8896 5.46245 10.9638 5.5268 11.0259L8.0868 13.5859C8.14877 13.6484 8.22251 13.698 8.30375 13.7319C8.38498 13.7657 8.47212 13.7831 8.56013 13.7831C8.64814 13.7831 8.73527 13.7657 8.81651 13.7319C8.89775 13.698 8.97149 13.6484 9.03346 13.5859L14.4735 8.14595C14.5411 8.08352 14.5951 8.00775 14.6321 7.92342C14.669 7.83909 14.6881 7.74802 14.6881 7.65595C14.6881 7.56388 14.669 7.47281 14.6321 7.38848C14.5951 7.30414 14.5411 7.22838 14.4735 7.16595Z"
            fill="white"
        />
    </svg>
);

// Validate props
SubmitPage.propTypes = {
    onPreviousStep: PropTypes.func,
};
